import React from 'react';

import './SearchPage.sass';

import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

import {fetchSearchByQuery} from '../../ducks/search';
import {fetchTaxonChildrenBySlug} from '../../ducks/taxons';
import {taxonNestedSet} from '../../utils/taxons';
import {setBackground} from '../../ducks/ui';

import Menu from '../../components/menu/Menu';
import CategoryMenu from '../../components/categoryMenu/CategoryMenu';
import Loader from '../../components/loader/Loader';
import LoadMore from '../../components/loadMore/LoadMore';
import SearchItems from '../../components/searchItem/SearchItems';
import Caption from '../../components/caption/Caption';
import ReviewsSwiper from '../../components/reviews/ReviewsSwiper';

@connect(({search, taxons}, {location}) => ({
  search: search[location.query.q],
  menu: taxons.children[process.env.ROOT_TAXON]
}))
export default class SearchPage extends React.PureComponent {
  static fetchData = ({dispatch, location}) => Promise.all([
    dispatch(fetchSearchByQuery(location.query.q)),
    dispatch(fetchTaxonChildrenBySlug(process.env.ROOT_TAXON))
  ]);

  componentDidMount() {
    const {dispatch, location, search, menu} = this.props;

    dispatch(setBackground());

    if (search === undefined) {
      dispatch(fetchSearchByQuery(location.query.q));
    }

    if (menu === undefined) {
      dispatch(fetchTaxonChildrenBySlug(process.env.ROOT_TAXON))
    }
  }

  componentWillReceiveProps(nextProps) {
    const {dispatch, location, search, menu} = nextProps;

    if (search === undefined) {
      dispatch(fetchSearchByQuery(location.query.q));
    }

    if (menu === undefined) {
      dispatch(fetchTaxonChildrenBySlug(process.env.ROOT_TAXON))
    }
  }

  loadMore = () => {
    const {dispatch, location, search} = this.props;
    dispatch(fetchSearchByQuery(location.query.q, search.page + 1));
  };

  render() {
    const {location, search, menu} = this.props;

    if (!search || !menu) {
      return <Loader page/>;
    }

    const menuTree = (menu && !!menu.length) && taxonNestedSet.nest(menu);

    return (
      <div className="container">
        <div className="row">
          {menuTree && <Menu items={menuTree}/>}

          <div className="page-search">
            {menuTree && <CategoryMenu title="Menu" items={menuTree}/>}

            <div className="page-search__text">
              <div className="page-search__header">
                <FormattedMessage id="page.search.results"/>{':'}
              </div>
              <div className="page-search__request">{location.query.q}</div>
            </div>

            <div className="page-search__results">
              {(search.isLoading || search.total > 0) ? (
                <LoadMore
                  component={SearchItems}
                  onLoadMore={this.loadMore}
                  {...search}
                />
              ) : (
                <Caption>
                  <FormattedMessage id="page.search.no-match"/>
                </Caption>
              )}
            </div>
          </div>
        </div>

        <div className="page-product__carousel">
          <div className="page-product__reviews">
            <ReviewsSwiper />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/searchPage/SearchPage.js